import { bootstrap } from '@bootstrap'

bootstrap()
